function makeSafeForCss( name ){ // make string fit the css spec. ie no spaces, lowercase, encoded, etc
	name = name || ''

	return name.replace( /[^a-z0-9]/g, function( s ){
		const c = s.charCodeAt( 0 )
		if( c === 32 ){
			return '-'
		}
		if( c >= 65 && c <= 90 ){
			return '' + s.toLowerCase()
		}
		return ( '000' + c.toString( 16 ) ).slice( -4 )
	})
}
const monthsList = ['January', 'February', 'March', 'April', 'May', 'June', 'July', 'August', 'September', 'October', 'November', 'December'],
	monthsListTruncated = monthsList.filter( ( month ) => {
		return month.substring( 0, 3 )
	})
function numberToMonth( month ){
	return monthsListTruncated[month]
}
function numberToMonthFull( month ){
	return monthsList[month]
}
function dateParts( unixtime ){
	const two = function( x ){
		return ( x > 9 ? '' : '0' ) + x
	}
	// let two = function(n){ return '0' + n.substr(-2) }; //I wonder which is faster. Probably the first

	unixtime = unixtime || new Date()
	unixtime = unixtime.toString().length === 10
		? unixtime * 1000
		: unixtime

	const
		date = unixtime ? new Date( unixtime ) : new Date(),
		 curDate = new Date(),
		 currentObj = {
			// seconds: two(curDate.getSeconds()),
			// minutes: two(curDate.getMinutes()),
			// hours: curDate.getHours(),
			day: curDate.getDate(),
			month: monthsListTruncated[curDate.getMonth()],
			year: curDate.getFullYear()
		},
		 dateObj = {
			seconds: two( date.getSeconds() ),
			minutes: two( date.getMinutes() ),
			hours: date.getHours(),
			day: date.getDate(),
			month: monthsListTruncated[date.getMonth()],
			fullMonth: monthsList[date.getMonth()],
			monthNumber: date.getMonth(),
			year: date.getFullYear()
		}

	if( currentObj.day !== dateObj.day ){
		if( currentObj.day - dateObj.day === 1 && currentObj.month === dateObj.month ){
			dateObj.day = 'Yesterday'
		} else {
			dateObj.day = currentObj.day === dateObj.day ? false : dateObj.day

			if( currentObj.day === dateObj.day ){
				dateObj.month = false
			}
		}
	}

	dateObj.year = currentObj.year === dateObj.year ? false : dateObj.year

	return dateObj
}

function makeTimestamp( unixtime, seconds ){
	const dateObj = dateParts( unixtime )

	return '' +
		( dateObj.year ? dateObj.year + ' ' : '' )		+
		( dateObj.month ? dateObj.month + ' ' : '' )		+
		( dateObj.day ? dateObj.day + ' ' : '' )		+
		( dateObj.hours + ':' + dateObj.minutes )		+
		( seconds ? ':' + dateObj.seconds : '' )
}

function makeTimestamp12hr( unixtime, seconds ){
	const dateObj = dateParts( unixtime ),

	 hours12 = function( num ){
			return ( num + 24 ) % 12 || 12
		}

	return '' +
		( dateObj.year ? dateObj.year + ' ' : '' )		+
		( dateObj.month ? dateObj.month + ' ' : '' )		+
		( dateObj.day ? dateObj.day + ' ' : '' )		+
		( hours12( dateObj.hours ) + ':' + dateObj.minutes )		+
		( seconds ? ':' + dateObj.seconds : '' ) +
		( dateObj.hours < 12 ? 'AM' : 'PM' )
}

function makeTimestampBak( unixtime, seconds ){
	const two = function( x ){
		return ( ( x > 9 ) ? '' : '0' ) + x
	}
	// let two = function(n){ return '0' + n.substr(-2) }; //I wonder which is faster. Probably the first
	if( unixtime && unixtime.toString().length === 10 ){
		unixtime = unixtime * 1000
	}
	const date = unixtime ? new Date( unixtime ) : new Date(),
	 curDate = new Date(),
	 monthsList = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec']
	let string = date.getHours() + ':' + two( date.getMinutes() )
	if( seconds === true ){
		string = string + ':' + two( date.getSeconds() )
	}
	const dateInt = date.getFullYear() + two( date.getMonth() ) + two( date.getDate() ),
	 curDateInt = curDate.getFullYear() + two( curDate.getMonth() ) + two( curDate.getDate() )
	if( curDateInt > dateInt ){
		if( ( curDateInt - dateInt ) == 1 ){
			string = 'Yesterday, ' + string
		} else {
			string = monthsList[date.getMonth()] + ' ' + date.getDate() + ', ' + string
			if( curDate.getFullYear() !== date.getFullYear() ){
				string = date.getFullYear() + ' ' + string
			}
		}
	} else if( curDateInt < dateInt ){
		if( ( dateInt - curDateInt ) == 1 ){
			string = 'Tomorrow, ' + string
		} else {
			string = monthsList[date.getMonth()] + ' ' + date.getDate() + ', ' + string
			if( curDate.getFullYear() !== date.getFullYear() ){
				string = date.getFullYear() + ' ' + string
			}
		}
	}

	return string
}

function quoteAttr( s, preserveCR ){
	preserveCR = preserveCR ? '&#13;' : '\n'
	return ( '' + s ) /* Forces the conversion to string. */
		.replace( /&/g, '&amp;' ) /* This MUST be the 1st replacement. */
		.replace( /'/g, '&apos;' ) /* The 4 other predefined entities, required. */
		.replace( /"/g, '&quot;' )
		.replace( /</g, '&lt;' )
		.replace( />/g, '&gt;' )
		.replace( /\r\n/g, preserveCR ) /* Must be before the next replacement. */
		.replace( /[\r\n]/g, preserveCR )
}
function unquoteAttr( s ){
	/*
    Note: this can be implemented more efficiently by a loop searching for
    ampersands, from start to end of ssource string, and parsing the
    character(s) found immediately after after the ampersand.
    */
	s = ( '' + s ) /* Forces the conversion to string type. */
	/* Decode by reversing the initial order of replacements. */
	s = s
		.replace( /\r\n/g, '\n' ) /* To do before the next replacement. */
		.replace( /[\r\n]/, '\n' )
		.replace( /&#13;&#10;/g, '\n' ) /* These 3 replacements keep whitespaces. */
		.replace( /&#1[03];/g, '\n' )
		.replace( /&#9;/g, '\t' )
		.replace( /&gt;/g, '>' ) /* The 4 other predefined entities required. */
		.replace( /&lt;/g, '<' )
		.replace( /&quot;/g, '"' )
		.replace( /&apos;/g, "'" )
	/* Required check for security! */
	var found = s.match( /&[^;]*;?/ )
	if( found && found.length && found[0] != '&amp;' ){ throw 'unsafe entity found in the attribute literal content' }
	/* This MUST be the last replacement. */
	return s.replace( /&amp;/g, '&' )
}

module.exports = {
	makeSafeForCss,
	dateParts,
	makeTimestamp,
	makeTimestamp12hr,
	quoteAttr,
	unquoteAttr,
	numberToMonthFull,
	numberToMonth
}